export const stockEmotions = [
    "Annoyed 🙄",
    "Anxious 😰",
    "Disappointed 🙁",
    "Empty 🫥",
    "Frustrated 😡",
    "Guilty 😓",
    "Hopeless 😶",
    "Lonely 😐",
    "Nervous 😰",
    "Overwhelmed 😵",
    "Sad 😭",
    "Stressed 😠",
    "Tired 😪",
    "Worried 😱"
  ];